.cardContainer:first-of-type {
    margin-top: var(--bi-scale-8x);
}

.chipContainer {
    display: flex;
    flex-wrap: wrap;
    gap: var(--bi-scale-2x);
    align-items: center;
}

/*  hack to align the error message box with the card */
.error {
    width: calc(100% + 5px);
    margin-left: -2px;
    margin-top: 3px;
    font-size: 1rem;
}
